"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable complexity */
var react_jss_1 = require("react-jss");
var ThemeProvider_1 = require("../../ThemeProvider");
var getColorTheme = function (theme) { return function (_a) {
    var brand = _a.brand, color = _a.color, mode = _a.mode;
    var themeColor = (0, ThemeProvider_1.buildTheme)(brand, mode);
    if (brand) {
        return color !== 'neutral' && color && themeColor.color[color];
    }
    return color !== 'neutral' && color && theme.color[color];
}; };
var styles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    root: {
        '& svg': {
            height: '100%',
            width: function (_a) {
                var size = _a.size;
                return size && theme.size[size];
            },
            '& path': {
                fill: function (_a) {
                    var color = _a.color, brand = _a.brand, size = _a.size, mode = _a.mode;
                    return (getColorTheme(theme)({
                        color: color,
                        brand: brand,
                        size: size,
                        mode: mode
                    }));
                }
            },
            '& path#id-avonV2-b-custom': {
                fill: function (_a) {
                    var color = _a.color;
                    return (color !== 'surface' ? '#fff' : '#000');
                }
            }
        }
    }
}); });
exports.default = styles;
//# sourceMappingURL=Logo.styles.js.map